import React from 'react';

import { Radio } from '@mui/material';
import { Row, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { customStyles, formatSocial } from '../utils';

import './styles.scoped.css';

const CheckPDFForm = ({ setForm, form, setIsSingle, isSingle, driverStatuses, handleViewResults }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };

  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <p style={{ marginTop: '20px' }}>
        Select to search by Single {t('edge_reporting.check_pdf.driver')} or Check Number
      </p>
      <span>
        <span className="radio-group">
          <Radio
            style={{
              transform: 'scale(1)',
            }}
            className="radio-button"
            onChange={() => setIsSingle(true)}
            checked={isSingle}
          />
          <span>Single {t('edge_reporting.check_pdf.driver')}</span>
        </span>
        <span className="radio-group">
          <Radio
            style={{
              transform: 'scale(1)',
              marginLeft: 50,
            }}
            className="radio-button"
            onChange={() => setIsSingle(false)}
            checked={!isSingle}
          />
          <span>Check Number</span>
        </span>
      </span>
      {isSingle ? (
        <div className="filters-row">
          <div className="filter-row">
            <Form.Group as={Row} controlId="EmpStatus" style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>{t('edge_reporting.check_pdf.driver')} Status</Form.Label>
              <div className="dropdown-spinner-container">
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  styles={customStyles('970px')}
                  options={driverStatuses}
                  isClearable
                  onChange={selectedOptions => {
                    const selectedCodes = selectedOptions.map(option => option.value);
                    setForm({
                      ...form,
                      EmpStatus: selectedCodes.join(','),
                    });
                  }}
                  value={form?.EmpStatus?.split(',').map(code => driverStatuses.find(option => option.value === code))}
                />
              </div>
            </Form.Group>
            x
          </div>
          <div className="filter-row">
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>{t('edge_reporting.check_pdf.driver_name')} Last Name</Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                as="input"
                name="EmplLastName"
                value={form?.EmplLastName}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label
                style={{
                  width: '120px',
                  marginLeft: '100px',
                  fontWeight: 'bold',
                }}>
                OR
              </Form.Label>
              <Form.Label
                style={{
                  width: '20px',
                  marginRight: '20px',
                }}>
                SSN
              </Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                as="input"
                name="SSNO"
                value={formatSocial(form?.SSNO || '')}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>{t('edge_reporting.check_pdf.driver_name')} First Name</Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                as="input"
                name="EmplFirstName"
                value={form?.EmplFirstName}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>{t('edge_reporting.check_pdf.employee')} Number</Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                type="number"
                as="input"
                name="EmpId"
                value={form?.EmpId}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div
            className="filter-row"
            style={{
              marginTop: '30px',
            }}>
            <Form.Group as={Row} controlId="FromPerEnddate" style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Period End Date</Form.Label>
              <Form.Control
                style={{
                  width: '150px',
                  height: '30px',
                  marginRight: '20px',
                }}
                as="input"
                type="date"
                name="FromPerEnddate"
                value={form?.FromPerEnddate}
                onChange={handleChange}
                max={form?.ToPerEnddate || undefined}
              />
            </Form.Group>
            <Form.Group as={Row} controlId="ToPerEnddate" style={{ alignItems: 'center' }}>
              <Form.Label
                style={{
                  width: '20px',
                  marginLeft: '30px',
                  marginRight: '20px',
                }}>
                To
              </Form.Label>
              <Form.Control
                style={{
                  width: '150px',
                  height: '30px',
                }}
                as="input"
                type="date"
                name="ToPerEnddate"
                value={form?.ToPerEnddate}
                onChange={handleChange}
                min={form?.FromPerEnddate || undefined}
              />
              <Form.Control.Feedback type="invalid" />
            </Form.Group>
          </div>
        </div>
      ) : (
        <div className="filter-row">
          <Form.Group as={Row} controlId="FromEmplLastName" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '100px' }}>Check #</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              name="checkId"
              value={form?.checkId}
              onChange={handleChange}
              type="number"
            />
          </Form.Group>
        </div>
      )}
      <div className="buttons-row">
        <Button variant="primary" onPress={handleViewResults} style={{ marginRight: '20px', width: '100px' }} text="View" />
        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default CheckPDFForm;
